import React from 'react'
import {connect} from 'react-redux'

import SDKApp from 'quiz-react-sdk/es/common/components/SDKApp'
import {rcsJwtRefreshFn} from '../actions/apiActions'

export const LtiSdkApp = ({
  rcsHost,
  rcsJwt,
  contextType,
  contextId,
  canvasHost,
  canvasToolId,
  userId,
  rcsJwtRefreshFn,
  timeZone,
  sdkTranslations,
  ...otherProps
}) => {
  const composeRceConfig = () => {
    return {
      rcsHost,
      rcsJwt,
      contextType,
      contextId: contextId?.toString() || null,
      canvasOrigin: canvasHost,
      canvasUserId: userId,
      rcsJwtRefreshFn,
      canvasToolId,
    }
  }

  return (
    <SDKApp
      appContainer="#root"
      timeZone={timeZone}
      translations={sdkTranslations}
      rceConfig={composeRceConfig()}
      {...otherProps}
    />
  )
}

export function mapStateToProps({context}) {
  return {
    timeZone: context.timeZone,
    sdkTranslations: context.sdkTranslations,
    rcsHost: context.rcsHost,
    rcsJwt: context.rcsJwt,
    contextId: context.canvasLocalContextId,
    userId: context.userCanvasId,
    contextType: context.contextType,
    canvasHost: context.canvasHost,
    canvasToolId: context.canvasToolId,
  }
}

const mapDispatchToProps = {
  rcsJwtRefreshFn,
}

export default connect(mapStateToProps, mapDispatchToProps)(LtiSdkApp)
